import React from 'react';
import { ArrowUpRightIcon, XIcon } from 'lucide-react';
import type { Partner } from '../../types/partners';
import { GET_STARTED_URL, SIGN_IN_URL } from '../../data/dgpt';
import { Dialog } from '../ui/Dialog';
import { PartnerLogo } from './PartnerLogo';
type SignInPromptProps = {
  partner: Partner | null;
  /** False while the votes service is unavailable — the prompt then says voting isn't open. */
  votingOpen: boolean;
  onClose: () => void;
};
export function SignInPrompt({
  partner,
  votingOpen,
  onClose
}: SignInPromptProps) {
  return <Dialog open={Boolean(partner)} onClose={onClose} labelledBy="signin-prompt-title" className="max-w-md" data-id="element-1127" data-mp="33er9oqtjdogl">
      {partner ? <div className="p-6 sm:p-7" data-id="element-1128" data-mp="2ufdz1utoetua">
          <div className="flex items-start justify-between gap-4" data-id="element-1129" data-mp="2ugfjur0huup7">
            <PartnerLogo partner={partner} className="h-7" data-id="element-1130" data-mp="wpckxembjd80" />
            <button type="button" onClick={onClose} aria-label="Close" className="-mr-2 -mt-2 inline-flex h-10 w-10 items-center justify-center rounded-lg text-text-tertiary hover:bg-elevated hover:text-text-primary focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime" data-id="element-1131" data-mp="wotdiruao788">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-1132" data-mp="2tid78vs898u2" />
            </button>
          </div>
          <h2 id="signin-prompt-title" className="mt-5 text-xl font-semibold tracking-[-0.02em] text-text-primary" data-id="element-1133" data-mp="2xieyeb0c6jv3">
            {votingOpen ? `Sign in to support ${partner.name}` : 'Partner voting opens soon'}
          </h2>
          <p className="mt-2 text-sm leading-relaxed text-text-secondary" data-id="element-1134" data-mp="3q7cec7h2s4ko">
            {votingOpen ? `Sign in to support ${partner.name} and discover more StartupFuel partners. Each account can upvote a partner once.` : `Upvotes are recorded against your StartupFuel account, one per partner. Sign in or create an account now to support ${partner.name} once voting opens.`}
          </p>
          <div className="mt-6 flex flex-col gap-2 sm:flex-row" data-id="element-1135" data-mp="cu92xxgl5p8e">
            <a href={SIGN_IN_URL} target="_blank" rel="noopener noreferrer" className="inline-flex min-h-[44px] flex-1 items-center justify-center gap-1.5 rounded-lg bg-lime px-4 text-sm font-semibold text-ink hover:bg-[#2B1E7A] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime focus-visible:ring-offset-2" data-id="element-1136" data-mp="mnwsm5phmt22">
              Sign In
              <ArrowUpRightIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-1137" data-mp="3rn7iyg6528k" />
              <span className="sr-only" data-id="element-1138" data-mp="3v3osievoukjv">(opens in a new tab)</span>
            </a>
            <a href={GET_STARTED_URL} target="_blank" rel="noopener noreferrer" className="inline-flex min-h-[44px] flex-1 items-center justify-center gap-1.5 rounded-lg border border-hairline bg-panel px-4 text-sm font-semibold text-text-primary hover:bg-elevated focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-lime" data-id="element-1139" data-mp="3r2d1c4x61r9k">
              Create an Account
              <span className="sr-only" data-id="element-1140" data-mp="321p4ek3kroup">(opens in a new tab)</span>
            </a>
          </div>
        </div> : null}
    </Dialog>;
}